import { DriveStyle } from "../../../utility/tdtService/Drive/Model/DriveStyle.js";
import { BusTransferType } from "../../../utility/tdtService/BusTransfer/Model/BusTransferType.js";
import { GuidUtility } from "../../../utility/common/GuidUtility.js";
import { ArrayUtility } from "../../../utility/common/ArrayUtility.js";


/**
 * 搜索参数
 */
export class RouteSearchParams {
    constructor() {
        /**
         * 搜索类型
         */
        this.searchType = RouteSearchType.national_drive;

        //驾车默认为最快路线
        this.driveTransferType = DriveStyle.LeastTime;
        //公交换乘类型默认为最快捷
        this.busTransferType = BusTransferType.MoreQuick;

        /**
         * 起点poi
         */
        this.startPoint = new RoutePOIInfo();

        /**
         * 终点poi
         */
        this.endPoint = new RoutePOIInfo();

        /**
         * 驾车途经点
         */
        this.driveViaPoints = new Array();
    }

    /**
     * 重置起点和终点关键词
     * @param {*} searchParams 
     */
    resetStartAndEndSuggestKey(searchParams)
    {   
        if(!searchParams)return;

        if(this.startPoint && searchParams.startPoint)
        {   
            if(this.startPoint.suggestKey !==searchParams.startPoint.suggestKey)
            {
                this.startPoint=searchParams.startPoint;
            }
        }

        if(this.endPoint && searchParams.endPoint)
        {   
            if(this.endPoint.suggestKey !==searchParams.endPoint.suggestKey)
            {
                this.endPoint=searchParams.endPoint;
            }
        }

    }


    /**
     * 检查建议词是否完整
     */
    checkSuggestKeyIntegrity() {
        if(this.startPoint 
            && this.startPoint.suggestKey 
            && this.endPoint
            && this.endPoint.suggestKey)
            {
                return true;
            }

        return false;

    }

    /**
     * 检查选择的POI完整性
     */
    checkPOIIntegrity() {
        let routePOIs = this.getRoutePOIs();
        let tempRoutePOI = null;
        for (let tempIndex = 0; tempIndex < routePOIs.length; tempIndex++) {
            tempRoutePOI = routePOIs[tempIndex];
            if (!tempRoutePOI.POI) {
                return false;
            }
        }

        return true;
    }

    /**
     * 检查起点和终点是否完整
     */
    checkStartAndEndPOIIntegrity()
    {   
        if(this.startPoint && this.startPoint.POI
            && this.endPoint && this.endPoint.POI)
            {
                return true;
            }

            return false;
    }

    /**
     * 获取线路poi数组
     */
    getRoutePOIs() {
        let routePOIs = new Array();

        if (this.searchType === RouteSearchType.national_busTransfer) {
            routePOIs.push(this.startPoint);
            routePOIs.push(this.endPoint);
        }
        else if (this.searchType === RouteSearchType.national_drive) {
            routePOIs.push(this.startPoint);
            ArrayUtility.addTargetToOri(routePOIs, this.driveViaPoints);
            routePOIs.push(this.endPoint);
        }

        return routePOIs;
    }

    /**
     * 设置poi点为空
     */
    setPOINull() {
        if (this.startPoint) {
            this.startPoint.POI = null;
        }

        if (this.endPoint) {
            this.endPoint.POI = null;
        }

        if (this.driveViaPoints && this.driveViaPoints.length > 0) {
            let tempViaPoint = null;
            for (let tempIndex = 0; tempIndex < this.driveViaPoints.length; tempIndex++) {
                tempViaPoint = this.driveViaPoints[tempIndex];
                if (tempViaPoint) {
                    tempViaPoint.POI = null;
                }
            }
        }
    }

}

/**
 * 线路poi信息
 */
export class RoutePOIInfo {

    constructor() {

        this.id = GuidUtility.getGuid();
        
        this.suggestKey = null;
        this.tip = null;
        this.POI = null;

        this.description=null;

        //是否已选择--界面ui使用属性
        this.selectStatus=false;
        

        //搜索出的poi数组--界面ui使用属性
        this.searchPOIs = new Array();
    }

    /**
     * 为poi属性信息设置为空
     * @param {*} routePOIInfoArray 
     */
    static setNullForPOIAttribute(routePOIInfoArray)
    {   
        if(!routePOIInfoArray)return;

        let tempPOIInfo=null;
        for(let tempIndex=0;tempIndex<routePOIInfoArray.length;tempIndex++)
        {   
            tempPOIInfo=routePOIInfoArray[tempIndex];
            if(tempPOIInfo)
            {
               tempPOIInfo.POI=null;
            }
        }

        
    }

    /**
     * 创建途经点
     */
    static createViaPoint() {
        let newViaPoint = new RoutePOIInfo();
        newViaPoint.id = GuidUtility.getGuid();
        newViaPoint.tip = "请输入途经点";

        return newViaPoint;
    }

    /**
     * 创建起点
     */
    static createStartPoint() {

        let startPoint = new RoutePOIInfo();
        startPoint.id = GuidUtility.getGuid();
        startPoint.tip = "请输入起点";

        return startPoint;


    }

    /**
     * 创建终点
     */
    static createEndPoint() {
        let endPoint = new RoutePOIInfo();
        endPoint.id = GuidUtility.getGuid();
        endPoint.tip = "请输入终点";
        return endPoint;
    }

    /**
     * 通过关键词查找
     * @param {*} poiInfos 
     * @param {*} suggestKey 
     */
    static findRoutePOI(poiInfos, suggestKey) {
        let findItem = null;
        if (!poiInfos || !suggestKey) return findItem;

        // poiInfos
        let tempPOIInfo = null;
        for (let tempIndex = 0; tempIndex < poiInfos.length; tempIndex++) {
            tempPOIInfo = poiInfos[tempIndex];
            if (tempPOIInfo.suggestKey === suggestKey) {
                findItem = tempPOIInfo;
                break;
            }
        }

        return findItem;
    }

    /**
     * 通过关键词查找索引
     * @param {*} poiInfos 
     * @param {*} suggestKey 
     */
    static findRoutePOIIndex(poiInfos, suggestKey) {
        let findIndex = -1;
        if (!poiInfos || !suggestKey) return findIndex;

        // poiInfos
        let tempPOIInfo = null;
        for (let tempIndex = 0; tempIndex < poiInfos.length; tempIndex++) {
            tempPOIInfo = poiInfos[tempIndex];
            if (tempPOIInfo.suggestKey === suggestKey) {
                findIndex = tempIndex;
                break;
            }
        }

        return findIndex;
    }


    /**
     * 通过关键词查找索引
     * @param {*} poiInfos 
     * @param {*} poiId 
     */
    static findRoutePOIIndexById(poiInfos, poiId) {
        let findIndex = -1;
        if (!poiInfos || !poiId) return findIndex;

        let tempPOIInfo = null;
        for (let tempIndex = 0; tempIndex < poiInfos.length; tempIndex++) {
            tempPOIInfo = poiInfos[tempIndex];
            if (tempPOIInfo.id === poiId) {
                findIndex = tempIndex;
                break;
            }
        }
        
        return findIndex;
    }


    /**
     * 获取途经点坐标串
     * @param {*} viaPoints 
     */
    static getViaPointCoorString(viaPoints) {

        let coorString = "";
        if (!viaPoints || !Array.isArray(viaPoints) || viaPoints.length === 0) return coorString;

        let tempViaPnt = null;
        for (let tempIndex = 0; tempIndex < viaPoints.length; tempIndex++) {
            tempViaPnt = viaPoints[tempIndex];
            if (!tempViaPnt.POI) continue;
            if (tempIndex < viaPoints.length - 1) {
                coorString += tempViaPnt.POI.x + "," + tempViaPnt.POI.y + ";";
            }
            else {
                coorString += tempViaPnt.POI.x + "," + tempViaPnt.POI.y;
            }
        }

        return coorString;
    }



}


/**
 * 路线搜索类型
 */
export const RouteSearchType =
{
    /**
     * 国家天地图公交换乘
     */
    national_busTransfer: "national_busTransfer",

    /**
     * 国家天地图乘车
     */
    national_drive: "national_drive"

}

/**
 * 线路事件
 */
export const UCRouteEvent =
{
    /**
     * 搜索输入uc组件-搜索单击事件
     */
    UCSearchInput_searchClick: "event_UCSearchInput_searchClick",

    /**
     * 搜索输入uc组件-搜索类型改变
     */
    UCSearchInput_searchTypeChange:"event_UCSearchInput_searchTypeChange",

    /**
     * 搜索输入uc组件-清除路线
     */
    UCSearchInput_clearRoute:"event_UCSearchInput_clearRoute",


    /**
     * 搜索poi结果uc组件-poi项拾取单击事件
     */
    UCSearchPOIResult_POIItemPickClick: "event_UCSearchPOIResult_POIItemPickClick",

    /**
     * 线路poi选择uc组件-所有poi点选择完成
     */
    UCRoutePOISelect_selectFinish: "event_UCRoutePOISelect_selectFinish",


    /**
     * 驾车线路uc组件--线路搜索完成
     */
    UCDriveRouteLine_routeSearchFinished: "event_UCDriveRouteLine_routeSearchFinished",

    /**
     * 驾车线路uc组件-单个线路项单击
     */
    UCDriveRouteLine_routeItemClick: "event_UCDriveRouteLine_routeItemClick",

    /**
     * 公交线路uc组件-公交换乘信息搜索完成
     */
    UCBusRouteLine_busTransferInfoSearchFinished: "event_UCBusRouteLine_busTransferInfoSearchFinished",

    /**
     * 公交线路uc组件-单个线路项单击事件
     */
    UCBusRouteLine_lineItemClick:"event_UCBusRouteLine_lineItemClick",

    /**
     * 公交驾乘线段项集合uc组件-线段项单击事件
     */
    UCBusSegmentItems_segmentItemClick:"event_UCBusSegmentItems_segmentItemClick",

    /**
     * 公交驾乘线段项集合uc组件-线段项终点名称单击事件
     */
    UCBusSegmentItems_segmentEndNameClick:"event_UCBusSegmentItems_segmentEndNameClick",

    /**
     * 搜索结果uc-搜索结果完成
     */
    UCSearchPOIResult_searchResultFinished:"event_UCSearchPOIResult_searchResultFinished"

}

/**
 * 路线常量
 */
export const UCRouteConstant =
{
    /**
     * 驾车类型数组
     */
    driveStyles: [
        {
            id: "0",
            label: "最快线路",
            name: "LeastTime"
        },
        {
            id: "1",
            label: "最短线路",
            name: "LeastDistance"
        },
        {
            id: "2",
            label: "少走高速",
            name: "AvoidHighways"
        }
    ],

    /**
     * 公交换乘类型数组
     */
    busTransferTypes: [
        {
            id: "0",
            label: "少换乘",
            name: "LessTransfer"
        },

        {
            id: "1",
            label: "少步行",
            name: "LessWalk"
        },

        {
            id: "2",
            label: "更快捷",
            name: "MoreQuick"
        }
        // ,

        // {
        //     id: "3",
        //     label: "不坐地铁",
        //     name: "NotSubway"
        // }
    ]




}
